export const environment = {
    production: true,
    local: false,
    appHost: 'https://app.qa.relationshipone.com',
    agentHost: 'https://agent.qa.relationshipone.com',
    appCloudHost: 'https://appcloud.qa.relationshipone.com',
    publicApiHost: 'https://api.appcloud.qa.relationshipone.com',
};
